export default __webpack_public_path__ + "static/skipblade-2681bbecb76a1faf5d66e42862b4cd37.png";